import { createStore } from 'redux';
import { isProd } from '../../env/enviroment';
import reducer from '../reducer';

const enhancer =
  (window as any).__REDUX_DEVTOOLS_EXTENSION__ &&
  (window as any).__REDUX_DEVTOOLS_EXTENSION__({ trace: true });

const store = isProd ? createStore(reducer) : createStore(reducer, enhancer);

export default store;
